export default "__VITE_ASSET__DHOVcyAS__"